interface IProp {
  country: string;
  flagIconCode: string;
}

export const CountryFlag = ({ country, flagIconCode }: IProp) => {
  const flagClassName = `fi fi-${flagIconCode.trim()}`;
  return (
    <div className="country">
      <div className={flagClassName} />
      <span>{country}</span>
    </div>
  );
};
